(function ($) {
  $(document).ready(function () {
    $("body").addClass("js");

    if ($(".js-header").length) {
      var stickyHeaderTop = $(".js-header").offset().top;
      stickyHeader(stickyHeaderTop);
    }

    if ($(".js-sticky-anchor").length) {
      var stickyAnchorTop = $(".js-sticky-anchor").offset().top;
      stickyAnchor(stickyAnchorTop);
    }

    $(window).on("scroll resize orientationchange", function () {
      if ($(".js-header").length) {
        stickyHeader(stickyHeaderTop);
      }

      if ($(".js-sticky-anchor").length) {
        stickyAnchor(stickyAnchorTop);
      }
    });

    // Initialize inline modals
    if ($("a.inline-modal").length) {
      $(".inline-modal").modaal();
    }

    // Initialize responsive tabs
    if ($(".nav-tabs").length) {
      $(".nav-tabs").responsiveTabs();
    }

    // Initialize responsive anchor tabs
    if ($(".anchor-links__list").length) {
      $(".anchor-links__list").responsiveTabs();
    }
  });

  // Sticky header
  var stickyHeader = function (stickyHeaderTop) {
    var scrollTop = $(window).scrollTop();

    if (scrollTop > stickyHeaderTop) {
      $("body").addClass("sticky-header");
    } else {
      $("body").removeClass("sticky-header");
    }
  };

  // Sticky anchor block
  var stickyAnchor = function (stickyAnchorTop) {
    var scrollTop = $(window).scrollTop() + 100;

    if (scrollTop > stickyAnchorTop) {
      $("body").addClass("sticky-anchors");
    } else {
      $("body").removeClass("sticky-anchors");
    }
  };
})(jQuery);
